<template>
  <div id="app">
    <router-view></router-view>
    <!-- 登录后全局挂载方案生态对话：否则仅在 /schemeEcosystem 子布局内才有 WS，停留在 /home 等页面时收不到实时推送 -->
    <DialogueCenter
      v-if="hasLoginToken && !hideGlobalDialogue"
      :embedded="true"
      :show-float="true"
      :reset-float-on-mount="false"
    />
    <!-- 注册云企业 -->
    <CloudAuthPopup />
    <!-- 工单下单 -->
    <WorkOrderPlacePopup />
    <!-- 登录弹窗 -->
    <LoginPopup />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CloudAuthPopup from '@/components/Popup/CloudEnterpriseAuth.vue'
import WorkOrderPlacePopup from '@/components/Popup/WorkOrderPlace.vue'
import LoginPopup from '@/components/LoginPopup/index.vue'
import DialogueCenter from '@/views/DialogueCenter.vue'

export default {
  name: 'App',
  components: {
    CloudAuthPopup,
    WorkOrderPlacePopup,
    LoginPopup,
    DialogueCenter
  },
  computed: {
    ...mapGetters(['token']),
    hasLoginToken() {
      return !!(this.token && String(this.token).trim())
    },
    hideGlobalDialogue() {
      return (this.$route.matched || []).some((record) => record.meta && record.meta.hideGlobalDialogue)
    }
  },
  mounted() {
    this.onStorageToken()
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.onStorageTokenChange)
  },
  methods: {
    /**
     * @description: 监听 token 变化，变化时刷新页面（一个标签页登录/退出，其他标签页同步）
     */
    onStorageToken() {
      window.addEventListener('storage', this.onStorageTokenChange)
    },
    onStorageTokenChange(event) {
      if (event.key === 'USER_TOKEN') {
        location.reload()
      }
    }
  }
}
</script>

<style lang="less">
</style>
